// src/pages/Contact/Contact.js
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === 'message') setCharCount(value.length);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    await new Promise(resolve => setTimeout(resolve, 1200));

    console.log('Form submitted:', formData);
    setSubmitted(true);
    setIsSubmitting(false);

    setTimeout(() => setSubmitted(false), 4000);
    setFormData({ name: '', email: '', subject: '', message: '' });
    setCharCount(0);
  };

  // Regional centres data with full details
  const regionalCentres = [
    {
      id: 1,
      city: 'Quetta',
      region: 'Balochistan',
      badge: 'BALOCHISTAN',
      image: '/images/regional/quetta.jpg',
      address: 'Industrial Estate, In-front of Utility Store Zonal Office, Sirki Road, Quetta',
      phone: '081-9211088',
      mobile: '+92 302 384-4602',
      email: 'Quetta@pitac.gov.pk',
    },
    {
      id: 2,
      city: 'Mirpur',
      region: 'Azad Jammu & Kashmir',
      badge: 'AJK',
      image: '/images/regional/ajk.jpg',
      address: 'House No. 141, Sector D-1, Allama Iqbal Road, Mirpur (AJK)',
      phone: '05827-920322',
      mobile: '',
      email: 'mirpur@pitac.gov.pk',
    },
    {
      id: 3,
      city: 'Gilgit',
      region: 'Gilgit-Baltistan',
      badge: 'GB',
      image: '/images/regional/gilgit.jpg',
      address: 'Building of Kashrote A Class Dispensary, Ehsan Ali Road, Kashrote, Gilgit (GB)',
      phone: '05811-942539',
      mobile: '',
      email: 'gilgit@pitac.gov.pk',
    },
    {
      id: 4,
      city: 'Peshawar',
      region: 'Khyber Pakhtunkhwa',
      badge: 'KPK',
      image: '/images/regional/kpk.jpg',
      address: 'Inside Govt. College of Technology, Kohat Road, Peshawar (KPK)',
      phone: '091-9210976',
      mobile: '',
      email: 'peshawar@pitac.gov.pk',
    },
    {
      id: 5,
      city: 'Karachi',
      region: 'Sindh',
      badge: 'SINDH',
      image: '/images/regional/karachi.jpg',
      address: 'House # 1/2 N, PECHS Block-06, Karachi (Sindh)',
      phone: '021-99333324',
      mobile: '',
      email: 'karachi@pitac.gov.pk',
    },
  ];

  return (
    <div className="contact-page">

      {/* ============ HERO ============ */}
      <section className="contact-hero">
        <div className="contact-hero-bg-pattern"></div>
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Let's Connect</h1>
          <p className="contact-hero-subtitle">
            Have a question about our programs, trainings, or regional services?<br />
            Our team is here to help you every step of the way.
          </p>

          <div className="contact-hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="hero-stat-text">
                <strong>5</strong>
                <span>Regional Centres</span>
              </div>
            </div>

            <div className="hero-stat">
              <div className="hero-stat-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div className="hero-stat-text">
                <strong>24/7</strong>
                <span>Support Available</span>
              </div>
            </div>

            <div className="hero-stat">
              <div className="hero-stat-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <div className="hero-stat-text">
                <strong>100%</strong>
                <span>Response Rate</span>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-hero-wave"></div>
      </section>

      {/* ============ MAIN ============ */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">

            {/* LEFT COLUMN */}
            <div className="contact-left">

              {/* Contact Info Card */}
              <div className="contact-info-card">
                <div className="card-header">
                  <div className="card-header-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                  </div>
                  <div>
                    <h2 className="card-title">Contact Information</h2>
                    <p className="card-subtitle">Reach out through any of these channels</p>
                  </div>
                </div>

                <div className="contact-details-list">
                  {/* Head Office */}
                  <div className="contact-detail-item">
                    <div className="contact-detail-icon green">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div className="contact-detail-content">
                      <h4>Head Office</h4>
                      <p>234-Ferozepur Road, near Metro Canal Station</p>
                      <p>Lahore 54600, Pakistan</p>
                    </div>
                  </div>

                  {/* Call Us */}
                  <div className="contact-detail-item">
                    <div className="contact-detail-icon green">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                      </svg>
                    </div>
                    <div className="contact-detail-content">
                      <h4>Call Us</h4>
                      <p>+92 42 9923 0699</p>
                      <p>+92 42 9923 0702</p>
                    </div>
                  </div>

                  {/* Email Us */}
                  <div className="contact-detail-item">
                    <div className="contact-detail-icon green">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="2" y="4" width="20" height="16" rx="2"/>
                        <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                      </svg>
                    </div>
                    <div className="contact-detail-content">
                      <h4>Email Us</h4>
                      <p>info@pitac.gov.pk</p>
                      <p>support@pitac.gov.pk</p>
                    </div>
                  </div>

                  {/* Working Hours */}
                  <div className="contact-detail-item">
                    <div className="contact-detail-icon green">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                      </svg>
                    </div>
                    <div className="contact-detail-content">
                      <h4>Working Hours</h4>
                      <p>Monday – Friday: 9:00 AM – 5:00 PM</p>
                      <p>Saturday – Sunday: Closed</p>
                    </div>
                  </div>
                </div>

                {/* Social Links */}
                <div className="social-links">
                  <h4>Follow Us</h4>
                  <div className="social-icons">
                    <a href="#" className="social-icon facebook" aria-label="Facebook">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    </a>
                    <a href="#" className="social-icon twitter" aria-label="X / Twitter">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>
                    </a>
                    <a href="#" className="social-icon linkedin" aria-label="LinkedIn">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </a>
                    <a href="#" className="social-icon youtube" aria-label="YouTube">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              {/* Send Message Form */}
              <div className="contact-form-card">
                <div className="card-header">
                  <div className="card-header-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 2L11 13"/>
                      <path d="M22 2L15 22l-4-9-9-4z"/>
                    </svg>
                  </div>
                  <div>
                    <h2 className="card-title">Send Us a Message</h2>
                    <p className="card-subtitle">Fill out the form and we'll get back to you within 24 hours.</p>
                  </div>
                </div>

                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name <span className="required">*</span></label>
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="John Doe"
                          className="form-input"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address <span className="required">*</span></label>
                      <div className="input-wrapper">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="john@example.com"
                          className="form-input"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject <span className="required">*</span></label>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        placeholder="How can we help you?"
                        className="form-input"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message <span className="required">*</span></label>
                    <div className="input-wrapper textarea-wrapper">
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="6"
                        maxLength="1000"
                        placeholder="Tell us about your inquiry in detail..."
                        className="form-textarea"
                      />
                      <div className="char-counter">{charCount} / 1000</div>
                    </div>
                  </div>

                  <button type="submit" className="submit-btn" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="spinner"></span>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </>
                    )}
                  </button>

                  <p className="form-privacy">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                    Your information is secure and will never be shared.
                  </p>

                  {submitted && (
                    <div className="success-message">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                        <polyline points="22 4 12 14.01 9 11.01"/>
                      </svg>
                      <span>Thank you! Your message has been sent successfully.</span>
                    </div>
                  )}
                </form>
              </div>
            </div>

            {/* RIGHT COLUMN — Regional Centres */}
            <div className="contact-right">
              <div className="regional-block">
                <div className="regional-block-header">
                  <div>
                    <h2 className="regional-block-title">Our Regional Centres</h2>
                    <p className="regional-block-subtitle">
                      PITAC operates across all provinces and regions of Pakistan
                    </p>
                  </div>
                  <div className="regional-count">05</div>
                </div>

                <div className="regional-cards-grid">
                  {regionalCentres.map((centre) => (
                    <div key={centre.id} className="regional-info-card">
                      <div className="regional-info-image-wrapper">
                        <img
                          src={centre.image}
                          alt={centre.city}
                          className="regional-info-image"
                          loading="lazy"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                        <span className="regional-info-badge">{centre.badge}</span>
                      </div>

                      <div className="regional-info-body">
                        <h3 className="regional-info-city">{centre.city}</h3>
                        <p className="regional-info-region">{centre.region}</p>

                        <ul className="regional-info-list">
                          <li>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                              <circle cx="12" cy="10" r="3"/>
                            </svg>
                            <span>{centre.address}</span>
                          </li>
                          <li>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                            </svg>
                            <span>{centre.phone}</span>
                          </li>
                          {centre.mobile && (
                            <li>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                                <line x1="12" y1="18" x2="12.01" y2="18"/>
                              </svg>
                              <span>{centre.mobile}</span>
                            </li>
                          )}
                          <li>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <rect x="2" y="4" width="20" height="16" rx="2"/>
                              <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                            </svg>
                            <span>{centre.email}</span>
                          </li>
                        </ul>

                        <div className="regional-info-socials">
                          <a href="#" className="regional-social facebook" aria-label="Facebook">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                            </svg>
                          </a>
                          <a href="#" className="regional-social twitter" aria-label="X">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                            </svg>
                          </a>
                          <a href="#" className="regional-social instagram" aria-label="Instagram">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                            </svg>
                          </a>
                          <a href="#" className="regional-social linkedin" aria-label="LinkedIn">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ============ MAP ============ */}
      <section className="map-section">
        <div className="container">
          <div className="map-header">
            <span className="map-tag">HEAD OFFICE</span>
            <h2 className="map-title">Find Us Here</h2>
            <p className="map-subtitle">
              Visit our head office at 234-Ferozepur Road, Lahore
            </p>
          </div>
          <div className="map-container">
            <iframe
              title="PITAC Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3400.0!2d74.3145!3d31.5204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919048e3f7a3e55%3A0x4b5e8f4c5c4b5e8f!2s234%20Ferozepur%20Rd%2C%20Lahore%2C%20Pakistan!5e0!3m2!1sen!2s!4v1641234567890!5m2!1sen!2s"
              width="100%"
              height="420"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;